import styled from '@emotion/styled/macro';
import * as utils from '@chronos/utils';

export const LabelList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 5px;
`;

export const Label = styled.div`
  display: inline-flex;
  max-width: calc(100% - 4px);
`;

export const LabelButton = styled.button`
  appearance: none;
  border: none;
  text-decoration: none;
  padding: 0 8px;
  position: relative;
  border-radius: 4px;
  min-width: 40px;
  max-width: 40px;
  height: 8px;
  color: #172b4d;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
  cursor: pointer;
  background: ${({ color, theme }) =>
    utils.getLabelHexColor(
      color,
      theme.dark ? 'foregroundColor' : 'backgroundColor'
    )};

  &:hover {
    // background-color: var(--hover-foreground-color, #dfe1e6);
    background: ${({ color, theme }) =>
      utils.getLabelHexColor(
        color,
        theme.dark ? 'hoverForegroundColor' : 'hoverBackgroundColor'
      )};
  }

  ${({ isExpanded, color, theme }) =>
    isExpanded &&
    `
    min-width: 56px;
    max-width: 100%;
    height: 16px;
    line-height: 16px;
    padding-left: 16px;
    &:hover:before {
      color: blue;
      background: ${utils.getLabelHexColor(
        color,
        theme.dark ? 'foregroundColor' : 'hoverForegroundColor'
      )};
    }

    &:before {
      color: red;
      background: ${utils.getLabelHexColor(
        color,
        theme.dark ? 'hoverForegroundColor' : 'hoverBackgroundColor'
      )};
      content: '';
      width: 8px;
      height: 8px;
      position: absolute;
      top: 4px;
      left: 4px;
      // bottom: 4px;
      border-radius: 50%;
    }

  `}

  ${(props) =>
    props.isLarge &&
    `
    font-size: 14px;
    min-width: 48px;
    height: 26px;
    line-height: 26px;
    padding-left: 26px;

    &::before {
      top: 7px;
      left: 7px;
      width: 13px;
      height: 13px;
    }
  `}
`;
